module.exports = "/_next/static/images/fb82dfd17b99f5ff4e91f22b044f71f1-savings-hero-xs.jpg";